module.exports = __webpack_public_path__ + "static/media/Prism element hierarchy (old).978ec12a.sketch";